import pluralize from 'pluralize';

/**
 * @param word : string
 * @returns lowercase a/an based on first letter of word
 */
export const getArticleForWord = (word: string) => {
  if (typeof word === 'string' && word.length > 0) {
    const lowerCaseFirstLetter = word[0].toLowerCase();
    if (['a', 'e', 'i', 'o', 'u'].includes(lowerCaseFirstLetter)) return 'an';
  }

  return 'a';
};

export enum StringModifier {
  TITLE_CASE,
  SENTENCE_CASE,
  PLURAL_TITLE_CASE,
  PLURAL_SENTENCE_CASE,
  UPPERCASE_ARTICLE,
  LOWERCASE_ARTICLE,
}

/**
 *
 * @param inputString a title case singular string
 * @param modifier one of the enums defined by StringModifier
 * @returns a modified string based on modifier
 */
export const modifyString = (inputString: string, modifier: StringModifier) => {
  if (typeof inputString !== 'string' || inputString.length === 0) return inputString;

  switch (modifier) {
    case StringModifier.TITLE_CASE:
      return inputString; // expectation is that inputString will always be Singular Title Case.
    case StringModifier.SENTENCE_CASE:
      return inputString.toLowerCase();
    case StringModifier.PLURAL_TITLE_CASE:
      return pluralize(inputString);
    case StringModifier.PLURAL_SENTENCE_CASE:
      return pluralize(inputString.toLowerCase());
    case StringModifier.LOWERCASE_ARTICLE:
      return getArticleForWord(inputString);
    case StringModifier.UPPERCASE_ARTICLE:
      return getArticleForWord(inputString).toUpperCase();

    default:
      return inputString; // If an invalid enum is provided return the original string
  }
};
